import React from 'react';
import { Offices } from './pages/OfficesList';
import { OfficesForm } from './pages/OfficesForm';

export const OfficesRoutes = [
  {
    path: '/escritorios',
    exact: true,
    component: () => <Offices />,
  },
  {
    path: '/escritorios/novo',
    exact: true,
    component: () => <OfficesForm />,
  },
  {
    path: '/escritorios/edit/:id',
    exact: true,
    component: () => <OfficesForm />,
  },
];
